/**
 * POST /chat/accion — respuestas instantáneas sobre el producto del caso (sin modelo):
 * más barato, otra forma, dosis por peso. Responde con la misma forma que el evento
 * `complete` de /chat.
 */
import { cerrarSesion } from '../utils/sesion'
import type { SseTerminalEvent } from '../types/sse'
import { leerSucursal } from '../hooks/useSucursal'

export type AccionCaso = 'mas_barato' | 'otra_forma' | 'dosis_peso' | 'promocion' | 'margen'

export interface AccionOpts {
  device_id: string
  device_token: string
  session_id: string
  accion: AccionCaso
  forma?: string
  peso_kg?: number
}

export type AccionRespuesta = Extract<SseTerminalEvent, { type: 'complete' }> & { pedido: string }

export async function pedirAccion(opts: AccionOpts): Promise<AccionRespuesta> {
  const res = await fetch('/api/chat/accion', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Device-Token': opts.device_token },
    body: JSON.stringify({
      device_id: opts.device_id,
      session_id: opts.session_id,
      accion: opts.accion,
      forma: opts.forma,
      peso_kg: opts.peso_kg,
      id_und_neg: leerSucursal()?.id_und_neg,
    }),
  })
  if (res.status === 401) cerrarSesion()
  if (!res.ok) {
    let detalle = ''
    try {
      detalle = (await res.json())?.detail ?? ''
    } catch {
      /* sin cuerpo */
    }
    throw new Error(detalle || `accion_${res.status}`)
  }
  return res.json()
}
